module.exports = __webpack_public_path__ + "resources/img/img_private_region.8e2e71f816e4ef156502944c853a9a8f.png";